import { render, staticRenderFns } from "./Costos.vue?vue&type=template&id=d326b3b4&scoped=true"
import script from "./Costos.vue?vue&type=script&lang=js"
export * from "./Costos.vue?vue&type=script&lang=js"
import style0 from "./Costos.vue?vue&type=style&index=0&id=d326b3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d326b3b4",
  null
  
)

export default component.exports